import CustomDialog from "../../../../core/components/ui/CustomDialog";
import {Box, CircularProgress} from "@mui/material";
import CustomDialogLoaderComponent from "../../../../core/components/common/custom-dialog-loader.component"
import CustomTypography from "../../../../core/components/ui/CustomTypography";
import useGatePassConfiguration from "../../hooks/useGatePassConfiguration";


const DeleteGatePassConfigurationDialog = (props) => {
    const {open, setOpen, selectedProfile} = props;

    const {isDeletingGatePassConfiguration, deleteProfileGatePassConfiguration} = useGatePassConfiguration();


    const handleClose = () => {
        setOpen(false);
    }

    const handleDeleteGatePass = () => {
        const parameters = {
            profile_gatepass_type_uid: selectedProfile?.profile_gatepass_type_uid,
        }

        deleteProfileGatePassConfiguration(parameters);
    }

    const actions = [
        {
            label: "Cancel",
            onClick: handleClose,
            variant: "outlined",
            customStyles: {
                opacity: 1, mr: 1
            }
        },
        {
            label: "Confirm",
            onClick: (e) => (!isDeletingGatePassConfiguration) ? handleDeleteGatePass(e) : null,
            customStyles: {
                visibility: (isDeletingGatePassConfiguration) ? "hidden" : "visible",
            },
        }
    ]

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={(isDeletingGatePassConfiguration) ? null : handleClose}
                title="Delete Confirmation"
                subtitle={""}
                hasDividers={false}
                content={
                    <Box>
                        {(isDeletingGatePassConfiguration) ?
                            <Box sx={{mb: "80px"}}>
                                <CustomDialogLoaderComponent 
                                    icon={<CircularProgress size={40} sx={{color: "#2196f3"}} />} 
                                    message={"Deleting profile gate pass configuration..."}
                                />
                            </Box>
                        : 
                            <>
                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Are you sure you want to delete this profile gate pass configuration?"}
                                />
                            </>
                        }
                    </Box>
                }
                actions={!isDeletingGatePassConfiguration && actions}
                maxWidth={"sm"}
                customStyles={{}}
                globalSx={globalSx}
            />
        </>
    )
}

export default DeleteGatePassConfigurationDialog
